export default [{
  path: '',
  component: () => import(/* webpackChunkName: 'contrato' */'@/views/private/frota/contrato/Main.vue'),
  children: [
    {
      path: 'contrato',
      name: 'frota.contrato',
      component: () => import(/* webpackChunkName: 'contrato' */'@/views/private/frota/contrato/ViewList.vue'),
    },
    {
      path: 'contrato/criar',
      name: 'frota.contrato.criar',
      component: () => import(/* webpackChunkName: 'contrato' */'@/views/private/frota/contrato/Criar.vue'),
    },
    {
      path: 'contrato/:id/editar',
      name: 'frota.contrato.editar',
      component: () => import(/* webpackChunkName: 'contrato' */'@/views/private/frota/contrato/Editar.vue'),
    },
  ],
}];
